var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15488 16H11.8447C13.5779 16 14.5631 15.0148 14.5631 13.2816V7.23375H8.5973C7.76719 7.23375 7.33846 6.80501 7.33846 5.97491V0H4.15488C2.42171 0 1.43652 0.98517 1.43652 2.71834V13.2816C1.43652 15.0148 2.42171 16 4.15488 16ZM9.10814 5.93843H14.5084C14.4901 5.51881 14.1435 5.11743 13.66 4.63397L9.91088 0.85746C9.47302 0.410478 9.06252 0.0729705 8.63379 0.0456015V5.47319C8.64291 5.78335 8.79798 5.93843 9.10814 5.93843ZM5.24041 10.2714C4.8664 10.2714 4.5745 9.9886 4.5745 9.61459C4.5745 9.24972 4.8664 8.96693 5.24041 8.96693H10.7592C11.1332 8.96693 11.4251 9.25883 11.4251 9.61459C11.4251 9.97947 11.1332 10.2714 10.7592 10.2714H5.24041ZM5.24041 13.0901C4.8664 13.0901 4.5745 12.8164 4.5745 12.4424C4.5745 12.0684 4.8664 11.7947 5.24041 11.7947H10.7592C11.1332 11.7947 11.4251 12.0775 11.4251 12.4424C11.4251 12.8073 11.1332 13.0901 10.7592 13.0901H5.24041Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ReportFilled.d8ffe3893413e63d6a0313de1cecf791.svg";